// French translations keyed by the exact English source string.
// t(text) returns FR[text] when French is active, otherwise the original English.
export const FR = {
  // ---------- Proposal / workflow ----------
  "View My Quote & Status": "Voir ma soumission et son statut",
  "Quote Submitted": "Soumission envoyée",
  "Quote Reviewed": "Soumission révisée",
  "Quote Accepted": "Soumission acceptée",
  "Payment": "Paiement",
  "Scheduled": "Planifié",
  "Completed": "Terminé",
  "Review Requested": "Avis demandé",
  "Your Quote & Booking Status": "Votre soumission et statut de réservation",
  "Quote": "Soumission",
  "Quote Details": "Détails de la soumission",
  "Quote Number": "Numéro de soumission",
  "Quote Date": "Date de la soumission",
  "Valid Until": "Valide jusqu'au",
  "Customer": "Client",
  "Service Address": "Adresse de service",
  "Postal code": "Code postal",
  "Size": "Taille",
  "Condition": "État",
  "None": "Aucun",
  "sq ft": "pi²",
  "bed": "ch.",
  "bath": "s.d.b.",
  "Scope of Work": "Étendue des travaux",
  "Important Notes, Terms & Conditions": "Notes importantes, termes et conditions",
  "Subtotal": "Sous-total",
  "GST (5%)": "TPS (5 %)",
  "QST (9.975%)": "TVQ (9,975 %)",
  "Total": "Total",
  "This is an estimated starting price — not a final invoice. Final pricing is confirmed by North Peak Facility Services after reviewing the job requirements.":
    "Ceci est un prix de départ estimé — et non une facture finale. Le prix final est confirmé par North Peak Facility Services après examen des exigences du travail.",
  "MANUAL REVIEW REQUIRED": "RÉVISION MANUELLE REQUISE",
  "North Peak Facility Services will review your request and confirm final pricing before the job is scheduled.":
    "North Peak Facility Services examinera votre demande et confirmera le prix final avant la planification des travaux.",
  "Accept Quote": "Accepter la soumission",
  "Request Final Quote": "Demander la soumission finale",
  "Our team is reviewing your request and will confirm your final quote shortly.":
    "Notre équipe examine votre demande et confirmera votre soumission finale sous peu.",
  "Request sent! We'll confirm your final quote shortly.": "Demande envoyée! Nous confirmerons votre soumission finale sous peu.",
  "Confirm Your Acceptance": "Confirmez votre acceptation",
  "taxes included": "taxes incluses",
  "I agree to the quoted scope of work.": "J'accepte l'étendue des travaux soumise.",
  "I agree to North Peak Facility Services' terms and cancellation policy.": "J'accepte les conditions et la politique d'annulation de North Peak Facility Services.",
  "I understand the quoted price and applicable taxes.": "Je comprends le prix soumis et les taxes applicables.",
  "Full service address (street, city, postal code)": "Adresse de service complète (rue, ville, code postal)",
  "Please fill in all fields, including the full service address.": "Veuillez remplir tous les champs, y compris l'adresse de service complète.",
  "Please confirm all three checkboxes to accept the quote.": "Veuillez cocher les trois cases pour accepter la soumission.",
  "Quote accepted! Check your email for confirmation.": "Soumission acceptée! Vérifiez votre courriel pour la confirmation.",
  "Cancel": "Annuler",
  "Pay Deposit": "Payer le dépôt",
  "Secure checkout powered by Stripe. Your booking is confirmed automatically once paid.":
    "Paiement sécurisé propulsé par Stripe. Votre réservation est confirmée automatiquement dès le paiement.",
  "Confirming your payment…": "Confirmation de votre paiement…",
  "Deposit received — your booking is confirmed!": "Dépôt reçu — votre réservation est confirmée!",
  "Payment cancelled — your quote is still waiting for you.": "Paiement annulé — votre soumission vous attend toujours.",
  "Payment session expired. Please try again.": "La session de paiement a expiré. Veuillez réessayer.",
  "We're still confirming your payment — refresh this page in a moment.":
    "Nous confirmons encore votre paiement — actualisez cette page dans un instant.",
  "Reserve your preferred time": "Réservez votre plage horaire préférée",
  "Your time is held for 30 minutes while you complete the deposit. It's only confirmed after payment.":
    "Votre plage est retenue 30 minutes pendant que vous complétez le dépôt. Elle n'est confirmée qu'après le paiement.",
  "Reserve This Time": "Réserver cette plage",
  "Time reserved! It's held for 30 minutes while you complete your deposit.":
    "Plage réservée! Elle est retenue 30 minutes pendant que vous complétez votre dépôt.",
  "Reserved for you until": "Réservée pour vous jusqu'à",
  "confirmed once your deposit is received.": "confirmée dès réception de votre dépôt.",
  "Your payment window expired and the reserved time was released. Please reserve a new time below.":
    "Votre fenêtre de paiement a expiré et la plage réservée a été libérée. Veuillez réserver une nouvelle plage ci-dessous.",
  "Payment Expired": "Paiement expiré",
  "Secure Your Booking": "Sécurisez votre réservation",
  "Deposit (25%)": "Dépôt (25 %)",
  "Your deposit is applied to the final invoice. The remaining balance is due upon completion.":
    "Votre dépôt est appliqué à la facture finale. Le solde restant est dû à la fin des travaux.",
  "Secure online payment is being finalized. We'll email you a payment link shortly — no action needed right now.":
    "Le paiement en ligne sécurisé est en cours de finalisation. Nous vous enverrons un lien de paiement par courriel sous peu — aucune action requise pour l'instant.",
  "Choose Your Appointment": "Choisissez votre rendez-vous",
  "Choose a 2-hour arrival window. Estimated duration:": "Choisissez une fenêtre d'arrivée de 2 heures. Durée estimée :",
  "Loading available times…": "Chargement des disponibilités…",
  "No available times right now — we'll contact you to schedule.": "Aucune disponibilité pour le moment — nous vous contacterons pour planifier.",
  "Confirm Appointment": "Confirmer le rendez-vous",
  "Appointment confirmed!": "Rendez-vous confirmé!",
  "Your Appointment": "Votre rendez-vous",
  "arrival window": "fenêtre d'arrivée",
  "Need to reschedule? Contact us at least 48 hours in advance.": "Besoin de reporter? Contactez-nous au moins 48 heures à l'avance.",
  "Thank you for choosing North Peak!": "Merci d'avoir choisi North Peak!",
  "We'd love your feedback — check your email for a quick review request.": "Votre avis compte — consultez votre courriel pour une courte demande d'évaluation.",
  "This quote has been cancelled. Contact us if you'd like a new quote.": "Cette soumission a été annulée. Contactez-nous pour une nouvelle soumission.",
  "This quote has expired. Contact us for an updated quote.": "Cette soumission a expiré. Contactez-nous pour une soumission à jour.",
  "This quote link is invalid or no longer available.": "Ce lien de soumission est invalide ou n'est plus disponible.",
  "Get a New Quote": "Obtenir une nouvelle soumission",
  "Loading…": "Chargement…",
  "New": "Nouveau",
  "Under Review": "En révision",
  "Quote Sent": "Soumission envoyée",
  "Manual Review": "Révision manuelle",
  "Accepted — Awaiting Payment": "Acceptée — En attente de paiement",
  "Paid — Scheduling Required": "Payée — Planification requise",
  "In Progress": "En cours",
  "Cancelled": "Annulée",
  // Scope of work lines
  "Dusting of all accessible surfaces": "Époussetage de toutes les surfaces accessibles",
  "Vacuuming and mopping of all floors": "Aspiration et lavage de tous les planchers",
  "Kitchen surfaces, sink and exterior of appliances": "Surfaces de cuisine, évier et extérieur des électroménagers",
  "Bathroom cleaning and sanitation": "Nettoyage et désinfection des salles de bain",
  "Trash removal": "Élimination des déchets",
  "Everything in a standard cleaning": "Tout ce qui est inclus dans un nettoyage standard",
  "Baseboards, door frames and light switches": "Plinthes, cadres de porte et interrupteurs",
  "Inside microwave and detailed kitchen degreasing": "Intérieur du micro-ondes et dégraissage détaillé de la cuisine",
  "Descaling of bathroom fixtures and tile": "Détartrage de la robinetterie et des carreaux de salle de bain",
  "Detailed dusting including vents and ceiling corners": "Époussetage détaillé incluant bouches d'aération et coins de plafond",
  "Full deep cleaning of the empty property": "Nettoyage en profondeur complet de la propriété vide",
  "Inside all cabinets, closets and drawers": "Intérieur de toutes les armoires, garde-robes et tiroirs",
  "Inside fridge and oven": "Intérieur du frigo et du four",
  "Baseboards, doors, switches and fixtures": "Plinthes, portes, interrupteurs et luminaires",
  "Floors washed and ready for handover": "Planchers lavés et prêts pour la remise",
  "Workstations, common areas and meeting rooms": "Postes de travail, aires communes et salles de réunion",
  "Floors vacuumed and mopped": "Planchers aspirés et lavés",
  "Kitchen / break room cleaning": "Nettoyage de la cuisine / salle de pause",
  "Restroom cleaning, sanitation and restocking": "Nettoyage, désinfection et réapprovisionnement des toilettes",
  "Trash removal and recycling": "Élimination des déchets et recyclage",
  "Pre-treatment of visible spots and stains": "Prétraitement des taches visibles",
  "Hot-water extraction deep clean per room": "Nettoyage en profondeur par extraction à l'eau chaude par pièce",
  "Deodorizing treatment": "Traitement désodorisant",
  "Quick-dry grooming": "Brossage séchage rapide",
  "Fabric-appropriate pre-treatment per piece": "Prétraitement adapté au tissu par meuble",
  "Deep extraction cleaning": "Nettoyage par extraction en profondeur",
  "Spot and odour treatment": "Traitement des taches et des odeurs",
  "Fast-dry finishing": "Finition séchage rapide",
  "Floor preparation and deep scrub": "Préparation et récurage en profondeur des planchers",
  "Machine buffing": "Polissage à la machine",
  "Application of protective wax / finish coats": "Application de couches de cire / finition protectrice",
  "Edge and corner detailing": "Finition des bordures et des coins",
  "Removal of construction dust from all surfaces": "Élimination de la poussière de construction sur toutes les surfaces",
  "Window, frame and sill detailing": "Nettoyage détaillé des fenêtres, cadres et rebords",
  "Floor scrub and finish": "Récurage et finition des planchers",
  "Fixture, cabinet and appliance detailing": "Nettoyage détaillé des luminaires, armoires et électroménagers",
  "Debris and packaging removal": "Élimination des débris et emballages",
  "Interior and exterior washing of up to 20 windows": "Lavage intérieur et extérieur jusqu'à 20 fenêtres",
  "Frames, sills and tracks wiped": "Cadres, rebords et rails essuyés",
  "Streak-free finish": "Finition sans traces",
  "Screens dusted": "Moustiquaires époussetées",
  "Interior and exterior washing per window": "Lavage intérieur et extérieur par fenêtre",
  "Frames and sills wiped": "Cadres et rebords essuyés",
  "Streak-free professional finish": "Finition professionnelle sans traces",
  // Terms
  "This quote is an estimated starting price based on the information provided. Final pricing is confirmed by North Peak Facility Services after reviewing the job requirements, and may be adjusted if the actual property size, condition or scope differs from what was submitted.":
    "Cette soumission est un prix de départ estimé basé sur les informations fournies. Le prix final est confirmé par North Peak Facility Services après examen des exigences du travail et peut être ajusté si la taille, l'état ou l'étendue réels diffèrent de ce qui a été soumis.",
  "The quote is valid for 7 days from the quote date. Expired quotes may be re-issued at current rates.":
    "La soumission est valide 7 jours à compter de sa date. Les soumissions expirées peuvent être réémises aux tarifs en vigueur.",
  "A 25% deposit is required to secure your booking. The deposit is applied to your final invoice.":
    "Un dépôt de 25 % est requis pour sécuriser votre réservation. Le dépôt est appliqué à votre facture finale.",
  "Cancellation / rescheduling: appointments may be cancelled or rescheduled free of charge with at least 48 hours notice. Cancellations with less than 48 hours notice may forfeit the deposit.":
    "Annulation / report : les rendez-vous peuvent être annulés ou reportés sans frais avec un préavis d'au moins 48 heures. Les annulations avec moins de 48 heures de préavis peuvent entraîner la perte du dépôt.",
  "Access: the customer must provide access to the property at the scheduled arrival window. If our team cannot access the property, the visit may be treated as a late cancellation.":
    "Accès : le client doit donner accès à la propriété durant la fenêtre d'arrivée prévue. Si notre équipe ne peut pas accéder à la propriété, la visite peut être traitée comme une annulation tardive.",
  "Applicable taxes (GST 5% + QST 9.975%) are added to all prices.":
    "Les taxes applicables (TPS 5 % + TVQ 9,975 %) s'ajoutent à tous les prix.",
  "Payment of the remaining balance is due upon completion of the work unless otherwise agreed in writing.":
    "Le paiement du solde restant est dû à la fin des travaux, sauf entente écrite contraire.",

  // ---------- Pricing V1.0 additions ----------
  "from $250": "à partir de 250 $",
  "from $350": "à partir de 350 $",
  "from $400": "à partir de 400 $",
  "$0.30/sq ft": "0,30 $/pi²",
  "$100/room": "100 $/pièce",
  "$50/piece": "50 $/meuble",
  "$1.50/sq ft": "1,50 $/pi²",
  "$0.75/sq ft": "0,75 $/pi²",
  "$200": "200 $",
  "$15/window": "15 $/fenêtre",
  "Move-In / Move-Out Cleaning": "Nettoyage emménagement / déménagement",
  "Commercial Cleaning": "Nettoyage commercial",
  "Carpet Cleaning": "Nettoyage de tapis",
  "Upholstery Cleaning": "Nettoyage de rembourrage",
  "Floor Buffing / Waxing": "Polissage / cirage de planchers",
  "Residential Window Cleaning": "Nettoyage de vitres résidentiel",
  "Commercial Window Cleaning": "Nettoyage de vitres commercial",
  "Number of Rooms": "Nombre de pièces",
  "Number of Pieces": "Nombre de meubles",
  "Number of Windows": "Nombre de fenêtres",
  "Square Footage": "Superficie (pi²)",
  "Inside Refrigerator": "Intérieur du réfrigérateur",
  "Interior Cabinet Cleaning": "Intérieur des armoires",
  "Window Sills & Tracks": "Rebords et rails de fenêtres",
  "Wall Spot Cleaning (per hour)": "Nettoyage de taches murales (à l'heure)",
  "Covers a standard home with up to 20 windows.": "Couvre une maison standard comptant jusqu'à 20 fenêtres.",
  "Commercial cleaning: Weekly saves 10%, Bi-weekly saves 5%.": "Nettoyage commercial : hebdomadaire −10 %, aux deux semaines −5 %.",
  "Request This Quote": "Demander cette soumission",
  "Please enter a valid phone number (10 digits).": "Veuillez entrer un numéro de téléphone valide (10 chiffres).",
  "Please enter a valid Canadian postal code (e.g. H2X 1Y4).": "Veuillez entrer un code postal canadien valide (ex. H2X 1Y4).",
  "This is an estimated starting price — not a final quote. Final pricing is confirmed by North Peak Facility Services after reviewing the job requirements.":
    "Ceci est un prix de départ estimé — et non une soumission finale. Le prix final est confirmé par North Peak Facility Services après examen des exigences du travail.",
  "Your request requires a manual review — we'll confirm final pricing before any work is scheduled.":
    "Votre demande nécessite une révision manuelle — nous confirmerons le prix final avant de planifier tout travail.",
  "Your request requires a manual review — a North Peak specialist will confirm your final pricing.":
    "Votre demande nécessite une révision manuelle — un spécialiste North Peak confirmera votre prix final.",
  "Manual quote required": "Soumission manuelle requise",
  "Manual quote required — final pricing will be confirmed by North Peak Facility Services.":
    "Soumission manuelle requise — le prix final sera confirmé par North Peak Facility Services.",
  "Estimated starting price": "Prix de départ estimé",
  "Pricing": "Tarification",
  "Post-construction job": "Travail après construction",
  "Very heavy condition reported": "État très encrassé signalé",
  "Large commercial area (over 10,000 sq ft)": "Grande surface commerciale (plus de 10 000 pi²)",
  "Large floor care area (over 5,000 sq ft)": "Grande surface de planchers (plus de 5 000 pi²)",
  "Specialized equipment / height / hazardous work mentioned": "Équipement spécialisé / hauteur / travaux dangereux mentionnés",

  // ---------- Quote Calculator (/quote) ----------
  "Free Quote Calculator": "Calculateur de soumission gratuite",
  "Get your free quote in under a minute.": "Obtenez votre soumission gratuite en moins d'une minute.",
  "Tell us about your space and see your estimated starting price instantly. We'll review your request and confirm your final quote.":
    "Décrivez votre espace et voyez instantanément votre prix de départ estimé. Nous réviserons votre demande et confirmerons votre soumission finale.",
  "Your Information": "Vos coordonnées",
  "Full Name": "Nom complet",
  "Phone": "Téléphone",
  "Email": "Courriel",
  "Postal Code": "Code postal",
  "Jane Tremblay": "Jeanne Tremblay",
  "Your Space": "Votre espace",
  "Service": "Service",
  "Property Type": "Type de propriété",
  "Office Square Footage": "Superficie du bureau (pi²)",
  "Bedrooms": "Chambres",
  "Bathrooms": "Salles de bain",
  "Studio": "Studio",
  "Property Condition": "État de la propriété",
  "Cleaning Frequency": "Fréquence de nettoyage",
  "Optional Add-ons": "Extras optionnels",
  "Additional Details": "Détails supplémentaires",
  "Anything else we should know — access instructions, pets, priority areas, special requests…":
    "Tout ce que nous devrions savoir — instructions d'accès, animaux, zones prioritaires, demandes spéciales…",
  "Standard Cleaning": "Nettoyage standard",
  "General Housekeeping": "Entretien ménager général",
  "Deep Cleaning": "Nettoyage en profondeur",
  "Moving-Related Cleaning": "Nettoyage de déménagement",
  "Office & Workplace Cleaning": "Nettoyage de bureaux",
  "Interior & Exterior Window Cleaning": "Nettoyage de vitres int. et ext.",
  "Post-Construction Cleaning": "Nettoyage après construction",
  "Apartment / Condo": "Appartement / Condo",
  "House": "Maison",
  "Townhouse": "Maison de ville",
  "Office / Commercial Space": "Bureau / Espace commercial",
  "Light — well maintained": "Léger — bien entretenu",
  "Average": "Moyen",
  "Heavy — needs extra attention": "Important — attention particulière requise",
  "Very heavy / major buildup": "Très important / accumulation majeure",
  "One-time": "Unique",
  "Weekly": "Hebdomadaire",
  "Bi-weekly": "Aux deux semaines",
  "Monthly": "Mensuel",
  "Inside Fridge": "Intérieur du frigo",
  "Inside Oven": "Intérieur du four",
  "Interior Windows": "Vitres intérieures",
  "Laundry & Folding": "Lessive et pliage",
  "Inside Cabinets": "Intérieur des armoires",
  "Balcony / Patio": "Balcon / Terrasse",
  "Carpet Shampoo": "Shampoing de tapis",
  "Disinfection": "Désinfection",
  "Your instant estimate": "Votre estimation instantanée",
  "Estimated Starting Price": "Prix de départ estimé",
  "From": "À partir de",
  "from": "à partir de",
  "per service": "par service",
  "per visit": "par visite",
  "Property": "Propriété",
  "Frequency": "Fréquence",
  "Add-ons": "Extras",
  "This is an estimated starting price — not a final quote. North Peak will review your request and confirm final pricing based on the actual property and scope of work.":
    "Ceci est un prix de départ estimé — et non une soumission finale. North Peak révisera votre demande et confirmera le prix final selon la propriété réelle et l'étendue des travaux.",
  "No obligation. We respond within one business day.": "Sans engagement. Réponse en un jour ouvrable.",
  "Managing a large facility?": "Vous gérez une grande installation?",
  "Enterprise Quote Wizard": "Soumission entreprise",
  "Please fill in your name, phone, email and postal code.": "Veuillez remplir votre nom, téléphone, courriel et code postal.",
  "Please enter a valid email address.": "Veuillez entrer une adresse courriel valide.",
  "Something went wrong. Please try again.": "Une erreur s'est produite. Veuillez réessayer.",
  "Request Received": "Demande reçue",
  "Thank you! Your quote request is in.": "Merci! Votre demande de soumission est reçue.",
  "We've emailed you a confirmation. A member of the North Peak team will contact you within one business day to confirm the details and your final price.":
    "Nous vous avons envoyé une confirmation par courriel. Un membre de l'équipe North Peak vous contactera en un jour ouvrable pour confirmer les détails et votre prix final.",
  "Reference ID": "Numéro de référence",
  "Back to Home": "Retour à l'accueil",

  // ---------- Header / nav / common CTAs ----------
  "Home": "Accueil",
  "AI Estimate": "Estimation IA",
  "Services": "Services",
  "Technology": "Technologie",
  "Industries": "Clientèle",
  "Who We Serve": "Notre clientèle",
  "About": "À propos",
  "Careers": "Carrières",
  "Contact": "Contact",
  "Portal": "Portail",
  "Client Portal": "Portail client",
  "Sign In": "Connexion",
  "Get a Quote": "Obtenir une soumission",
  "Request a Quote": "Demander une soumission",
  "Get Your Free Quote": "Obtenez votre soumission gratuite",
  "Book Your Free Site Assessment": "Réservez votre évaluation gratuite",
  "Schedule a Walkthrough": "Planifier une visite",
  "Learn more": "En savoir plus",
  "Explore Services": "Découvrir les services",
  "Company": "Entreprise",
  "Support": "Assistance",
  "Reach Us": "Nous joindre",
  "Privacy": "Confidentialité",
  "Terms": "Conditions",
  "Accessibility": "Accessibilité",

  // ---------- Hero ----------
  "Professional Cleaning & Facility Services": "Services professionnels de nettoyage et d'entretien",
  "Elevating": "Des services d'entretien commercial",
  "Every Space.": "fiables pour les entreprises modernes.",
  "Professional cleaning and facility services for homes, businesses, medical facilities, retail spaces, industrial properties, short-term rentals, and more. Every space receives the same attention to detail, reliability, and care.":
    "Services professionnels de nettoyage et d'entretien pour les résidences, les entreprises, les établissements médicaux, les commerces, les propriétés industrielles, les locations à court terme et plus encore. Chaque espace reçoit la même attention aux détails, la même fiabilité et le même soin.",

  // ---------- Trust band ----------
  "Trusted by homeowners, property managers, offices, healthcare facilities, and businesses of every size.":
    "La confiance des propriétaires, gestionnaires d'immeubles, bureaux, établissements de santé et entreprises de toutes tailles.",
  "Homeowners": "Propriétaires",
  "Property Managers": "Gestionnaires d'immeubles",
  "Corporate Offices": "Bureaux d'entreprise",
  "Healthcare Facilities": "Établissements de santé",
  "Retail Spaces": "Commerces",
  "Short-Term Rentals": "Locations à court terme",
  "Industrial Plants": "Sites industriels",

  // ---------- Who We Serve ----------
  "One standard of care, every kind of space.": "Une norme de soin, pour chaque type d'espace.",
  "Proudly serving Montreal and the Greater Montreal Area — from family homes to enterprise facilities.":
    "Fièrement au service de Montréal et du Grand Montréal — des résidences familiales aux grandes installations.",
  "Residential Homes": "Résidences",
  "Recurring, deep & one-time home cleaning.": "Nettoyage résidentiel récurrent, en profondeur ou ponctuel.",
  "Offices": "Bureaux",
  "Workspaces that stay spotless and professional.": "Des espaces de travail impeccables et professionnels.",
  "Medical Facilities": "Établissements médicaux",
  "Clinics & practices with strict hygiene standards.": "Cliniques et cabinets aux normes d'hygiène strictes.",
  "Retail": "Commerces",
  "Storefronts that make a first impression.": "Des espaces commerciaux qui font bonne impression.",
  "Industrial": "Industriel",
  "Warehouses & plants kept safe and orderly.": "Entrepôts et usines sûrs et bien ordonnés.",
  "Common areas & multi-unit buildings.": "Aires communes et immeubles à logements multiples.",
  "Airbnb": "Airbnb",
  "Fast, reliable short-term rental turnovers.": "Rotations rapides et fiables pour locations à court terme.",
  "Post-Construction": "Après-construction",
  "Debris & dust removal, move-in ready.": "Retrait des débris et poussières, prêt à emménager.",

  // ---------- Feature cards / FEATURES ----------
  "Outcomes that protect your home and business.": "Des résultats qui protègent votre résidence et votre entreprise.",
  "Reliable Service": "Service fiable",
  "Consistent quality backed by detailed digital inspections on every visit.":
    "Une qualité constante appuyée par des inspections numériques détaillées à chaque visite.",
  "Transparent Reporting": "Rapports transparents",
  "Digital reports, before-and-after photos, and complete service history.":
    "Rapports numériques, photos avant-après et historique complet des services.",
  "Trained Professionals": "Professionnels formés",
  "Background-checked, uniformed, fully insured and bonded staff.":
    "Personnel vérifié, en uniforme, entièrement assuré et cautionné.",
  "Technology Enabled": "Propulsé par la technologie",
  "Online client portal for scheduling, communication, and reporting.":
    "Portail client en ligne pour la planification, la communication et les rapports.",

  // ---------- WHY ----------
  "Response Coverage": "Couverture d'intervention",
  "Round-the-clock dispatch and account support across every region we serve.":
    "Répartition et soutien à la clientèle en tout temps dans chaque région desservie.",
  "Quality Score": "Indice de qualité",
  "Measured via digital inspections and independent client satisfaction audits.":
    "Mesuré par inspections numériques et audits indépendants de satisfaction.",
  "Sq. Ft. Serviced": "Pi² entretenus",
  "Managed daily across offices, clinics, retail and industrial portfolios.":
    "Gérés quotidiennement dans les bureaux, cliniques, commerces et sites industriels.",
  "Insured & Vetted": "Assurés et vérifiés",
  "Every technician is background-checked, trained, bonded and fully insured.":
    "Chaque technicien est vérifié, formé, cautionné et entièrement assuré.",

  // ---------- PROCESS ----------
  "Consultation": "Consultation",
  "We walk your facility, understand your standards, and map every requirement in detail.":
    "Nous visitons vos lieux, comprenons vos exigences et cartographions chaque besoin en détail.",
  "Custom Program": "Programme sur mesure",
  "A tailored scope, schedule and staffing plan engineered around your operations and budget.":
    "Une portée, un horaire et un plan de personnel adaptés à vos opérations et à votre budget.",
  "Execution": "Exécution",
  "Vetted, trained crews deliver the plan with precision, backed by dedicated account management.":
    "Des équipes vérifiées et formées exécutent le plan avec précision, avec une gestion de compte dédiée.",
  "Quality Assurance": "Assurance qualité",
  "Digital inspections, real-time reporting and proactive reviews keep quality relentlessly high.":
    "Inspections numériques, rapports en temps réel et suivis proactifs pour une qualité irréprochable.",

  // ---------- FAQ ----------
  "What types of facilities do you service?": "Quels types d'établissements desservez-vous?",
  "We service corporate offices, medical clinics, retail properties, industrial facilities, multi-unit buildings, and logistics centers — from single sites to nationwide portfolios.":
    "Nous desservons les bureaux, cliniques médicales, commerces, sites industriels, immeubles à logements multiples et centres logistiques — d'un seul site à de vastes portefeuilles.",
  "How quickly can you start a new contract?": "En combien de temps pouvez-vous démarrer un nouveau contrat?",
  "Most programs are mobilized within 7–14 days of a signed agreement, following an on-site walkthrough and a custom program design.":
    "La plupart des programmes démarrent en 7 à 14 jours après la signature, à la suite d'une visite des lieux et d'un plan sur mesure.",
  "Are your teams insured and background-checked?": "Vos équipes sont-elles assurées et vérifiées?",
  "Yes. Every North Peak technician is fully insured, bonded, background-checked, and trained to our quality and safety standards.":
    "Oui. Chaque technicien North Peak est entièrement assuré, cautionné, vérifié et formé selon nos normes de qualité et de sécurité.",
  "Do you offer green and sustainable cleaning?": "Offrez-vous un nettoyage écologique et durable?",
  "Absolutely. We offer eco-certified products, sustainable waste and recycling programs, and green-clean protocols on request.":
    "Absolument. Nous offrons des produits écocertifiés, des programmes de gestion durable des déchets et du recyclage, ainsi que des protocoles écologiques sur demande.",
  "How do you ensure consistent quality?": "Comment assurez-vous une qualité constante?",
  "We use digital inspections, real-time reporting dashboards, and dedicated account managers who conduct proactive quality reviews.":
    "Nous utilisons des inspections numériques, des tableaux de bord en temps réel et des gestionnaires de compte dédiés qui effectuent des suivis proactifs.",

  // ---------- Testimonials / Reviews ----------
  "Director of Facilities, Meridian Tower": "Directeur des installations, Meridian Tower",
  "North Peak transformed the presentation of our Class-A tower. Their reporting and consistency are unlike any vendor we've worked with.":
    "North Peak a transformé la présentation de notre tour de catégorie A. Leurs rapports et leur constance surpassent tous nos fournisseurs précédents.",
  "Practice Manager, Lakeside Medical": "Gestionnaire de clinique, Lakeside Medical",
  "The clinical-grade sanitation gives our patients confidence the moment they walk in. Reliable, discreet, and always thorough.":
    "La désinfection de qualité clinique rassure nos patients dès leur arrivée. Fiables, discrets et toujours minutieux.",
  "Regional Ops, Northgate Retail": "Opérations régionales, Northgate Retail",
  "Across 12 retail locations, standards never slip. One partner, one point of contact, zero headaches.":
    "Dans nos 12 commerces, les normes ne faiblissent jamais. Un seul partenaire, un seul contact, aucun tracas.",
  "Plant Manager, Apex Industrial": "Directeur d'usine, Apex Industrial",
  "They understand industrial environments. Safety-first crews and floor care that actually protects our investment.":
    "Ils comprennent les milieux industriels. Des équipes axées sur la sécurité et un entretien des planchers qui protège notre investissement.",
  "Impeccable service and communication. Our lobby has never looked better.":
    "Service et communication impeccables. Notre hall n'a jamais été aussi beau.",
  "Professional crews, on time every single day. Highly recommend.":
    "Des équipes professionnelles, ponctuelles chaque jour. Fortement recommandé.",
  "The quality reporting keeps everyone accountable. Best facility partner we've had.":
    "Les rapports de qualité responsabilisent tout le monde. Le meilleur partenaire d'entretien que nous ayons eu.",
  "Great value for a large commercial contract. Responsive account team.":
    "Excellent rapport qualité-prix pour un grand contrat commercial. Équipe de compte réactive.",

  // ---------- SERVICES (short) ----------
  "Daily Janitorial": "Conciergerie quotidienne",
  "Consistent, detail-driven daily cleaning tailored to your workflow and traffic patterns.":
    "Nettoyage quotidien constant et minutieux, adapté à votre flux de travail et à l'achalandage.",
  "Deep Cleaning": "Nettoyage en profondeur",
  "Periodic top-to-bottom sanitation that resets your facility to pristine condition.":
    "Assainissement périodique de fond en comble qui remet vos lieux à neuf.",
  "Floor & Carpet Care": "Entretien des planchers et tapis",
  "Stripping, waxing, buffing, and extraction that protects and extends every surface.":
    "Décapage, cirage, polissage et extraction qui protègent et prolongent chaque surface.",
  "Window & Glass": "Vitres et verre",
  "Interior and high-rise exterior glass cleaning by trained, insured technicians.":
    "Nettoyage des vitres intérieures et extérieures en hauteur par des techniciens formés et assurés.",
  "Waste & Recycling": "Déchets et recyclage",
  "Streamlined collection and sustainable disposal programs for busy facilities.":
    "Collecte simplifiée et programmes d'élimination durables pour les installations achalandées.",
  "Disinfection Programs": "Programmes de désinfection",
  "Hospital-grade disinfection for high-touch points and shared environments.":
    "Désinfection de qualité hospitalière pour les points de contact et les espaces partagés.",

  // ---------- SERVICES_FULL ----------
  "Commercial Cleaning": "Nettoyage commercial",
  "Comprehensive daily cleaning programs engineered for high-traffic commercial environments.":
    "Programmes de nettoyage quotidien complets, conçus pour les environnements commerciaux à fort achalandage.",
  "Medical Clinics": "Cliniques médicales",
  "Clinical-grade sanitation compliant with healthcare hygiene and infection-control standards.":
    "Assainissement de qualité clinique conforme aux normes d'hygiène et de contrôle des infections.",
  "Office Cleaning": "Nettoyage de bureaux",
  "Immaculate workspaces that keep teams productive and impress every visitor.":
    "Des espaces de travail impeccables qui gardent les équipes productives et impressionnent chaque visiteur.",
  "Spotless storefronts and sales floors that elevate the customer experience.":
    "Des vitrines et surfaces de vente impeccables qui rehaussent l'expérience client.",
  "Heavy-duty programs for plants, warehouses and distribution centers, built for scale.":
    "Programmes robustes pour usines, entrepôts et centres de distribution, conçus à grande échelle.",
  "Floor Care": "Entretien des planchers",
  "Stripping, waxing, buffing and polishing that protects and extends every surface.":
    "Décapage, cirage, polissage et lustrage qui protègent et prolongent chaque surface.",
  "Carpet Cleaning": "Nettoyage de tapis",
  "Deep extraction and stain treatment that restores carpets to like-new condition.":
    "Extraction en profondeur et traitement des taches qui redonnent aux tapis un aspect neuf.",
  "Window Cleaning": "Nettoyage de vitres",
  "Post Construction": "Après-construction",
  "Detailed final cleans that turn a finished build into a move-in ready space.":
    "Nettoyages finaux détaillés qui transforment un chantier terminé en espace prêt à emménager.",
  "Facility Maintenance": "Entretien d'immeuble",
  "Proactive facility support that keeps your building running flawlessly year-round.":
    "Un soutien proactif qui garde votre immeuble en parfait état toute l'année.",
  // includes items
  "Daily janitorial": "Conciergerie quotidienne",
  "Common areas & lobbies": "Aires communes et halls",
  "Restroom sanitation": "Assainissement des toilettes",
  "Trash & recycling": "Déchets et recyclage",
  "Hospital-grade disinfection": "Désinfection de qualité hospitalière",
  "Exam & treatment rooms": "Salles d'examen et de traitement",
  "Waiting areas": "Salles d'attente",
  "Biohazard protocols": "Protocoles de risques biologiques",
  "Workstations & desks": "Postes et bureaux",
  "Conference rooms": "Salles de conférence",
  "Break rooms & kitchens": "Salles de pause et cuisines",
  "Glass & partitions": "Verre et cloisons",
  "Sales floor care": "Entretien des surfaces de vente",
  "Fitting rooms": "Cabines d'essayage",
  "Entrances & glass": "Entrées et vitres",
  "High-touch sanitizing": "Désinfection des points de contact",
  "Warehouse floors": "Planchers d'entrepôt",
  "Loading docks": "Quais de chargement",
  "Machinery areas": "Zones de machinerie",
  "Safety compliance": "Conformité en sécurité",
  "Strip & wax": "Décapage et cirage",
  "Buffing & burnishing": "Polissage et lustrage",
  "Tile & grout": "Tuiles et coulis",
  "Concrete polishing": "Polissage du béton",
  "Hot water extraction": "Extraction à l'eau chaude",
  "Spot & stain removal": "Détachage",
  "Deodorizing": "Désodorisation",
  "Traffic-lane treatment": "Traitement des zones de passage",
  "Interior glass": "Vitres intérieures",
  "High-rise exterior": "Extérieur en hauteur",
  "Frames & sills": "Cadres et rebords",
  "Streak-free finish": "Fini sans traces",
  "Debris removal": "Retrait des débris",
  "Dust elimination": "Élimination des poussières",
  "Fixture detailing": "Nettoyage des luminaires et accessoires",
  "Final polish": "Polissage final",
  "Preventive maintenance": "Entretien préventif",
  "Handyman services": "Services d'homme à tout faire",
  "Supply management": "Gestion des fournitures",
  "24/7 response": "Intervention 24/7",

  // ---------- INDUSTRIES ----------
  "Corporate Offices ": "Bureaux d'entreprise",
  "Class-A towers, campuses & coworking floors kept immaculate around the clock.":
    "Tours de catégorie A, campus et espaces de cotravail impeccables en tout temps.",
  "Clinical-grade sanitation compliant with healthcare hygiene standards.":
    "Assainissement de qualité clinique conforme aux normes d'hygiène de la santé.",
  "Retail Properties": "Propriétés commerciales",
  "Storefronts and malls presented flawlessly for every customer visit.":
    "Vitrines et centres commerciaux présentés à la perfection à chaque visite.",
  "Industrial Facilities": "Installations industrielles",
  "Heavy-duty programs for plants, warehouses and distribution centers.":
    "Programmes robustes pour usines, entrepôts et centres de distribution.",
  "Multi-Unit Buildings": "Immeubles à logements multiples",
  "Common areas, lobbies and amenities maintained to a premium standard.":
    "Aires communes, halls et commodités entretenus selon une norme supérieure.",
  "Logistics & Warehousing": "Logistique et entreposage",
  "Large-footprint floor care and dock maintenance built for scale.":
    "Entretien des planchers de grande surface et des quais, conçu à grande échelle.",

  // ---------- COMMITMENTS ----------
  "Fast Quote Turnaround": "Soumission rapide",
  "Instant AI estimates and formal proposals within one business day.":
    "Estimations IA instantanées et propositions officielles en un jour ouvrable.",
  "Flexible Scheduling": "Horaire flexible",
  "Daytime, evening, overnight and weekend programs that fit your operation.":
    "Programmes de jour, de soir, de nuit et de fin de semaine adaptés à vos opérations.",
  "Insured Professionals": "Professionnels assurés",
  "Every technician is fully insured, bonded, and background-checked.":
    "Chaque technicien est entièrement assuré, cautionné et vérifié.",
  "Customized Plans": "Plans personnalisés",
  "Scopes engineered around your facility, traffic, and standards.":
    "Des portées conçues selon vos lieux, votre achalandage et vos normes.",

  // ---------- PORTAL_FEATURES ----------
  "Request Service": "Demander un service",
  "Book one-time or recurring service in a few taps.": "Réservez un service ponctuel ou récurrent en quelques clics.",
  "View Schedules": "Consulter l'horaire",
  "See every upcoming and completed visit at a glance.": "Voyez d'un coup d'œil chaque visite à venir et terminée.",
  "Download Invoices": "Télécharger les factures",
  "Access and pay invoices with full billing history.": "Consultez et payez vos factures avec l'historique complet.",
  "Inspection Reports": "Rapports d'inspection",
  "Review digital quality inspections after each visit.": "Consultez les inspections numériques après chaque visite.",
  "Before / After Photos": "Photos avant / après",
  "Visual proof of work for every service, archived by date.": "Preuve visuelle du travail pour chaque service, archivée par date.",
  "Message Your Team": "Écrire à votre équipe",
  "Direct, documented communication with your account manager.": "Communication directe et documentée avec votre gestionnaire de compte.",

  // ---------- POSITIONS ----------
  "Commercial Cleaning Technician": "Technicien(ne) en nettoyage commercial",
  "Floor Care Specialist": "Spécialiste de l'entretien des planchers",
  "Site Supervisor": "Superviseur(e) de site",
  "Account Manager": "Gestionnaire de compte",
  "Multiple Locations": "Emplacements multiples",
  "Metro Region": "Région métropolitaine",
  "Downtown District": "Centre-ville",
  "Regional Office": "Bureau régional",
  "Full-time": "Temps plein",

  // ---------- Footer ----------
  "Let's elevate your space.": "Rehaussons votre espace.",
  "Get a tailored, no-obligation quote and experience the North Peak standard — for your home or business.":
    "Obtenez une soumission sur mesure, sans obligation, et découvrez la norme North Peak — pour votre résidence ou votre entreprise.",
  "Proudly serving Montreal and the Greater Montreal Area — homes, offices, medical facilities, retail, industrial properties and short-term rentals.":
    "Fièrement au service de Montréal et du Grand Montréal — résidences, bureaux, établissements médicaux, commerces, propriétés industrielles et locations à court terme.",
  "Serving Montreal & the Greater Montreal Area, Quebec": "Au service de Montréal et du Grand Montréal, Québec",
  "Email us anytime · Response within one business day": "Écrivez-nous en tout temps · Réponse en un jour ouvrable",
  "© 2026 North Peak Facility Services. All Rights Reserved.": "© 2026 North Peak Facility Services. Tous droits réservés.",

  // ---------- Contact page ----------
  "Contact · Montreal, Quebec": "Contact · Montréal, Québec",
  "Let's Discuss Your Cleaning Needs.": "Parlons de vos besoins en nettoyage.",
  "Whether you need residential cleaning, commercial cleaning, post-construction cleaning, or facility services, our team is ready to help.":
    "Que vous ayez besoin de nettoyage résidentiel, commercial, après-construction ou de services d'entretien, notre équipe est prête à vous aider.",
  "Proudly serving the Greater Montreal Area.": "Fièrement au service du Grand Montréal.",
  "Service Area": "Zone desservie",
  "Montreal & the Greater Montreal Area, Quebec": "Montréal et le Grand Montréal, Québec",
  "Availability": "Disponibilité",
  "Email us anytime": "Écrivez-nous en tout temps",
  "Response within one business day": "Réponse en un jour ouvrable",
  "Email": "Courriel",
  "General": "Général",
  "Sales": "Ventes",
  "Quotes": "Soumissions",
  "Careers": "Carrières",
  "Operations": "Opérations",
  "Billing": "Facturation",
  "Request your free quote": "Demandez votre soumission gratuite",
  "Name *": "Nom *",
  "Company (optional)": "Entreprise (facultatif)",
  "Email *": "Courriel *",
  "Phone": "Téléphone",
  "Property Address": "Adresse de la propriété",
  "Property Type": "Type de propriété",
  "Service Requested": "Service demandé",
  "Tell us about your space and needs *": "Parlez-nous de votre espace et de vos besoins *",
  "Request My Free Quote": "Demander ma soumission gratuite",
  "Sending…": "Envoi en cours…",
  "Thank you for contacting North Peak Facility Services.": "Merci d'avoir communiqué avec North Peak Facility Services.",
  "A member of our team will respond within one business day.": "Un membre de notre équipe vous répondra en un jour ouvrable.",
  // property types / services (Contact selects)
  "Residential Home": "Résidence",
  "Office": "Bureau",
  "Medical Facility": "Établissement médical",
  "Retail Space": "Commerce",
  "Industrial Property": "Propriété industrielle",
  "Short-Term Rental / Airbnb": "Location à court terme / Airbnb",
  "Property Management": "Gestion immobilière",
  "Other": "Autre",
  "Residential Cleaning": "Nettoyage résidentiel",
  "Move-Out Cleaning": "Nettoyage de déménagement",
  "Post-Construction Cleaning": "Nettoyage après-construction",
  "Recurring / Janitorial": "Récurrent / Conciergerie",
  "Facility Services": "Services d'entretien",
  // toasts
  "Please fill in your name, email and message.": "Veuillez indiquer votre nom, votre courriel et votre message.",
  "Request sent! We'll respond within one business day.": "Demande envoyée! Nous répondrons en un jour ouvrable.",
  "Something went wrong. Please try again.": "Une erreur est survenue. Veuillez réessayer.",

  // ---------- Section overlines (shared) ----------
  "Our Services": "Nos services",
  "Why North Peak": "Pourquoi North Peak",
  "Our Process": "Notre processus",
  "Testimonials": "Témoignages",
  "Frequently Asked Questions": "Questions fréquentes",
  "Reviews": "Avis",
  "The North Peak Standard": "La norme North Peak",

  // ---------- Home sections (inline) ----------
  "Why It Matters": "Pourquoi c'est important",
  "We don't just clean buildings. We help businesses run better.": "Nous ne faisons pas que nettoyer des immeubles. Nous aidons les entreprises à mieux fonctionner.",
  "North Peak helps you maintain healthier, safer, and more professional environments through reliable facility services, transparent communication, and technology-driven operations.":
    "North Peak vous aide à maintenir des environnements plus sains, plus sûrs et plus professionnels grâce à des services fiables, une communication transparente et des opérations appuyées par la technologie.",
  "Commercial Cleaning Services": "Services de nettoyage commercial",
  "A complete facility program under one roof.": "Un programme d'entretien complet sous un même toit.",
  "Explore all services": "Voir tous les services",
  "Industries We Serve": "Secteurs desservis",
  "Built for the environments that demand more.": "Conçu pour les environnements les plus exigeants.",
  "View all industries": "Voir tous les secteurs",
  "How It Works": "Comment ça fonctionne",
  "From first walkthrough to lasting standard.": "De la première visite à une norme durable.",
  "Technology Platform": "Plateforme technologique",
  "The North Peak Portal — a competitive advantage most cleaners don't have.": "Le portail North Peak — un avantage concurrentiel que peu d'entreprises de nettoyage offrent.",
  "Request service, view schedules, download invoices, access inspection reports, review before/after photos, and message your team — all in one place.":
    "Demandez un service, consultez les horaires, téléchargez les factures, accédez aux rapports d'inspection, revoyez les photos avant/après et écrivez à votre équipe — le tout au même endroit.",
  "Explore the Platform": "Découvrir la plateforme",
  "Before/After Photos": "Photos avant/après",
  "Message Team": "Écrire à l'équipe",
  "Customer Testimonials": "Témoignages de clients",
  "Trusted by facility leaders across every sector.": "La confiance des gestionnaires d'installations de tous les secteurs.",
  "· Verified Google Reviews": "· Avis Google vérifiés",
  "Frequently Asked": "Foire aux questions",
  "Questions, answered.": "Vos questions, nos réponses.",
  "Ready to elevate your space?": "Prêt à rehausser votre espace?",
  "Book a free site assessment and see the North Peak difference firsthand.": "Réservez une évaluation gratuite et constatez la différence North Peak.",

  // ---------- Page heros (Services/Industries/About/Careers/Technology/Quote) ----------
  "Everything your facility needs.": "Tout ce dont votre espace a besoin.",
  "Our Services": "Nos services",
  "From daily janitorial to specialized deep cleaning, we deliver a complete facility program tailored to your space.":
    "De la conciergerie quotidienne au nettoyage en profondeur spécialisé, nous offrons un programme complet adapté à votre espace.",

  // ---------- Services page ----------
  "Every service your facility needs, delivered with precision.": "Chaque service dont votre espace a besoin, exécuté avec précision.",
  "Ten specialized programs, one accountable partner — engineered for the standards of premium commercial properties.":
    "Dix programmes spécialisés, un partenaire responsable — conçus selon les normes des propriétés commerciales haut de gamme.",
  "Learn More": "En savoir plus",
  "Not sure which program fits?": "Vous ne savez pas quel programme choisir?",
  "Try our AI Quote Generator for an instant, tailored estimate — or book a free walkthrough.":
    "Essayez notre générateur de soumission IA pour une estimation instantanée et sur mesure — ou réservez une visite gratuite.",
  "Get an Instant Quote": "Obtenir une estimation instantanée",
  "Book a Walkthrough": "Réserver une visite",
  "Request a Quote for": "Demander une soumission pour",

  // ---------- Industries page ----------
  "Specialized programs for every commercial environment.": "Des programmes spécialisés pour chaque environnement commercial.",
  "From medical clinics to industrial plants, we tailor standards, staffing, and compliance to your sector.":
    "Des cliniques médicales aux usines industrielles, nous adaptons les normes, le personnel et la conformité à votre secteur.",
  "Your sector not listed? We likely serve it.": "Votre secteur n'est pas listé? Nous le desservons probablement.",
  "Talk to our team": "Parler à notre équipe",
  "Corporate Offices": "Bureaux d'entreprise",

  // ---------- About page ----------
  "About North Peak": "À propos de North Peak",
  "A facility partner engineered for the long term.": "Un partenaire d'entretien conçu pour le long terme.",
  "We built North Peak on a simple belief: commercial spaces perform better when they're cared for with enterprise discipline and genuine craft.":
    "Nous avons bâti North Peak sur une conviction simple : les espaces commerciaux fonctionnent mieux lorsqu'ils sont entretenus avec une rigueur d'entreprise et un véritable savoir-faire.",
  "Our Mission": "Notre mission",
  "Reliability you can build a business on.": "Une fiabilité sur laquelle bâtir votre entreprise.",
  "North Peak Facility Services delivers commercial cleaning and facility support that meets the standards of the most demanding environments — from Class-A office towers to medical clinics and industrial plants.":
    "North Peak Facility Services offre un nettoyage commercial et un soutien d'entretien qui répondent aux normes des environnements les plus exigeants — des tours de bureaux de catégorie A aux cliniques médicales et aux usines industrielles.",
  "Every engagement is backed by vetted, insured crews, dedicated account management, and a quality assurance program that turns \"clean\" into a measurable, repeatable outcome.":
    "Chaque mandat est appuyé par des équipes vérifiées et assurées, une gestion de compte dédiée et un programme d'assurance qualité qui transforme le « propre » en un résultat mesurable et reproductible.",
  "Work with us": "Travailler avec nous",
  "How We Work": "Notre façon de travailler",
  "A proven method, applied to every facility.": "Une méthode éprouvée, appliquée à chaque espace.",

  // ---------- Careers page ----------
  "Build your career at North Peak.": "Bâtissez votre carrière chez North Peak.",
  "Join a team that treats facility services as a craft — with training, growth, and genuine respect for the people who deliver it.":
    "Joignez-vous à une équipe qui considère l'entretien comme un métier — avec formation, croissance et un respect sincère pour ceux qui l'exécutent.",
  "Open Positions": "Postes ouverts",
  "Now hiring across our regions.": "Nous embauchons dans toutes nos régions.",
  "Apply Now": "Postuler maintenant",
  "Application received!": "Candidature reçue!",
  "Thanks for your interest in North Peak. Our talent team will be in touch if there's a match.":
    "Merci de votre intérêt envers North Peak. Notre équipe des talents vous contactera en cas de correspondance.",
  "Apply": "Postuler",
  "Submit your application.": "Soumettez votre candidature.",
  "Full name *": "Nom complet *",
  "Position *": "Poste *",
  "Preferred location": "Emplacement préféré",
  "Years of experience": "Années d'expérience",
  "Tell us about yourself": "Parlez-nous de vous",
  "Submitting…": "Soumission en cours…",
  "Submit Application": "Soumettre la candidature",
  "Please fill in your name, email and desired position.": "Veuillez indiquer votre nom, votre courriel et le poste souhaité.",
  "Application submitted! Our team will review it shortly.": "Candidature soumise! Notre équipe l'examinera sous peu.",

  // ---------- Technology page ----------
  "Facility management, engineered like software.": "La gestion d'immeuble, conçue comme un logiciel.",
  "North Peak pairs elite crews with a technology platform that makes quality measurable, scheduling effortless, and communication instant.":
    "North Peak associe des équipes d'élite à une plateforme technologique qui rend la qualité mesurable, la planification simple et la communication instantanée.",
  "The Platform": "La plateforme",
  "One connected system, end to end.": "Un système connecté, de bout en bout.",
  "AI Quote Generator": "Générateur de soumission IA",
  "Instant, data-driven estimates — labour hours, staffing, and pricing generated in seconds.":
    "Des estimations instantanées et fondées sur les données — heures de travail, personnel et tarification générés en quelques secondes.",
  "Real-time visibility into services, invoices, contracts, and before/after photos.":
    "Une visibilité en temps réel sur les services, les factures, les contrats et les photos avant/après.",
  "Quality Dashboard": "Tableau de bord qualité",
  "Digital inspections and live quality scores keep every site accountable.":
    "Les inspections numériques et les indices de qualité en direct responsabilisent chaque site.",
  "Employee Mobile App": "Application mobile des employés",
  "GPS clock-in, checklists, photo capture and signatures — all in the field.":
    "Pointage GPS, listes de vérification, photos et signatures — le tout sur le terrain.",
  "Live": "En ligne",
  "Coming Soon": "Bientôt disponible",
  "Try it now": "Essayer maintenant",
  "North Peak Portal": "Portail North Peak",
  "Everything your team needs, in one login.": "Tout ce dont votre équipe a besoin, en une seule connexion.",
  "A single portal that turns facility management into a transparent, on-demand experience for every client.":
    "Un portail unique qui transforme la gestion d'immeuble en une expérience transparente et à la demande pour chaque client.",
  "Powered by AI": "Propulsé par l'IA",
  "An AI layer across the entire operation.": "Une couche d'IA sur l'ensemble des opérations.",
  "From instant quotes to route optimization and predictive inventory, our roadmap brings intelligence to every corner of facility management.":
    "Des soumissions instantanées à l'optimisation des trajets et à l'inventaire prédictif, notre feuille de route apporte l'intelligence à chaque aspect de la gestion d'immeuble.",
  "Experience the AI Quote Generator": "Découvrir le générateur de soumission IA",
  "AI Customer Support": "Soutien client IA",
  "AI Scheduling": "Planification IA",
  "AI Route Optimization": "Optimisation des trajets IA",
  "AI Quote Assistant": "Assistant de soumission IA",
  "AI Cleaning Checklist": "Liste de vérification de nettoyage IA",
  "AI Staff Assignment": "Affectation du personnel IA",
  "AI Inventory Forecast": "Prévision d'inventaire IA",
  "AI Email & Proposal Writer": "Rédacteur de courriels et de propositions IA",

  // ---------- Quote Wizard ----------
  "Enterprise Facility Consultation": "Consultation en entretien d'entreprise",
  "Request a tailored proposal.": "Demandez une proposition sur mesure.",
  "A few details help us prepare an accurate scope and pricing before your free on-site walkthrough.":
    "Quelques détails nous aident à préparer une portée et une tarification exactes avant votre visite gratuite sur place.",
  "Company": "Entreprise",
  "Facility": "Établissement",
  "Frequency": "Fréquence",
  "Requirements": "Exigences",
  "Walkthrough": "Visite",
  "Review": "Révision",
  "Company Information": "Informations sur l'entreprise",
  "Facility Information": "Informations sur l'établissement",
  "Service Requirements": "Besoins de service",
  "Cleaning Frequency": "Fréquence de nettoyage",
  "Special Requirements": "Exigences particulières",
  "Preferred Site Walkthrough": "Visite des lieux souhaitée",
  "Review & Submit": "Réviser et soumettre",
  "Step": "Étape",
  "of 7": "sur 7",
  "Company Name *": "Nom de l'entreprise *",
  "Contact Person *": "Personne-ressource *",
  "Position": "Poste",
  "Preferred Contact": "Contact préféré",
  "Facility Name": "Nom de l'établissement",
  "Industry": "Secteur",
  "Select…": "Sélectionner…",
  "Building Address": "Adresse de l'immeuble",
  "City": "Ville",
  "Province": "Province",
  "Postal Code": "Code postal",
  "Building Size (sq ft)": "Superficie (pi²)",
  "Floors": "Étages",
  "Washrooms": "Toilettes",
  "Employees": "Employés",
  "Occupancy Type": "Type d'occupation",
  "Select all services you're interested in.": "Sélectionnez tous les services qui vous intéressent.",
  "Security clearance required": "Habilitation de sécurité requise",
  "After-hours only": "En dehors des heures d'ouverture seulement",
  "Green cleaning": "Nettoyage écologique",
  "Hospital-grade disinfection": "Désinfection de qualité hospitalière",
  "Upload floor plans": "Téléverser les plans d'étage",
  "Upload photos": "Téléverser des photos",
  "Soon": "Bientôt",
  "Special Instructions": "Instructions particulières",
  "Anything else we should know?": "Autre chose à savoir?",
  "Preferred Date": "Date préférée",
  "Preferred Time": "Heure préférée",
  "Contact": "Contact",
  "Location": "Emplacement",
  "Size": "Superficie",
  "Back": "Retour",
  "Continue": "Continuer",
  "Submit Request": "Soumettre la demande",
  "Please enter company name, contact person and email.": "Veuillez saisir le nom de l'entreprise, la personne-ressource et le courriel.",
  "Please select at least one service.": "Veuillez sélectionner au moins un service.",
  "Please choose a cleaning frequency.": "Veuillez choisir une fréquence de nettoyage.",
  "Request submitted — check your inbox!": "Demande soumise — vérifiez votre boîte de réception!",
  "Request received!": "Demande reçue!",
  "Thank you,": "Merci,",
  "A North Peak specialist will reach out within one business day to confirm your site assessment. A confirmation email is on its way.":
    "Un spécialiste de North Peak vous contactera en un jour ouvrable pour confirmer votre évaluation sur place. Un courriel de confirmation est en route.",
  "Your Reference ID": "Votre numéro de référence",
  "Back to Home": "Retour à l'accueil",
  "Try the AI Estimator": "Essayer l'estimateur IA",
  "Corporate Office": "Bureau d'entreprise",
  "Medical / Healthcare": "Médical / Santé",
  "Industrial / Warehouse": "Industriel / Entrepôt",
  "Multi-Unit Building": "Immeuble à logements multiples",
  "Education": "Éducation",
  "Hospitality": "Hôtellerie",
  "Medical Facility Cleaning": "Nettoyage d'établissement médical",
  "Retail Cleaning": "Nettoyage de commerce",
  "Industrial Cleaning": "Nettoyage industriel",
  "Post Construction Cleaning": "Nettoyage après-construction",
  "Day Porter": "Préposé de jour",
  "Daily": "Quotidien",
  "Weekdays": "Jours de semaine",
  "3x Weekly": "3x par semaine",
  "Weekly": "Hebdomadaire",
  "Bi-Weekly": "Aux deux semaines",
  "Monthly": "Mensuel",
  "Custom": "Personnalisé",
  "Morning": "Matin",
  "Afternoon": "Après-midi",
  "Evening": "Soir",
  "Either": "L'un ou l'autre",
  "Single-tenant": "Locataire unique",
  "Multi-tenant": "Multi-locataires",
  "Owner-occupied": "Occupé par le propriétaire",
  "Mixed-use": "Usage mixte",
};
